class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", (event) => {
      event.preventDefault();
      const cartItems =
        this.closest("cart-items") || this.closest("cart-drawer-items");
      cartItems.updateQuantity(this.dataset.index, 0);

      //when fucker removes the item from cart.
      
setTimeout(function () {
  const cartItems = document.querySelectorAll(".cart-item");
  let found = false;

  cartItems.forEach(function (item) {
    if (found) return;

    const attrib = item.getAttribute("data-sellingplan");

    if (attrib) {
      const upsellBtns = document.querySelectorAll(".upsell-product-btn button");

      upsellBtns.forEach(function (btn) {
        const upsellPlan = btn.getAttribute("data-sellingplan");

        const existingInput = btn.parentElement.querySelector(".sellingplancart");
        if (existingInput) existingInput.remove(); 

        if (upsellPlan) {
          const hiddenInput = document.createElement("input");
          hiddenInput.type = "hidden";
          hiddenInput.className = "sellingplancart";
          hiddenInput.name = "selling_plan";
          hiddenInput.value = upsellPlan;

          btn.parentElement.insertBefore(hiddenInput, btn);
        }
      });
 var shipping_protection = document.querySelector("#privacy_protection_input");
if (shipping_protection) {
  shipping_protection.setAttribute("data-selling", "12512690340");
}
      found = true;
    } else {
      const upsellBtns = document.querySelectorAll(".upsell-product-btn button");

      upsellBtns.forEach(function (btn) {
        const existingInput = btn.parentElement.querySelector(".sellingplancart");
        if (existingInput) existingInput.remove();
      });
        var shipping_protection = document.querySelector("#privacy_protection_input");
if (shipping_protection) {
  shipping_protection.setAttribute("data-selling", "false");
}

      console.log("No selling plan on this cart item — upsell selling plans removed.");
    }
  }); 
}, 2000);

 checkboxmain();
      //end
      
    });
  }
}

customElements.define("cart-remove-button", CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById("shopping-cart-line-item-status") ||
      document.getElementById("CartDrawer-LineItemStatus");

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener("change", debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.cartUpdate,
      (event) => {
        if (event.source === "cart-items") {
          return;
        }
        this.onCartUpdate();
      }
    );
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  onChange(event) {
    this.updateQuantity(
      event.target.dataset.index,
      event.target.value,
      document.activeElement.getAttribute("name"),
      event.target.dataset.quantityVariantId
    );
   
  }

  onCartUpdate() {
    if (this.tagName === "CART-DRAWER-ITEMS") {
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(
            responseText,
            "text/html"
          );
          const selectors = ["cart-drawer-items", ".cart-drawer__footer"];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(
            responseText,
            "text/html"
          );
          const sourceQty = html.querySelector("cart-items");
          this.innerHTML = sourceQty.innerHTML;
        })
        .catch((e) => {
          console.error(e);
        });
    }
   
  }

  getSectionsToRender() {
    return [
      {
        id: "main-cart-items",
        section: document.getElementById("main-cart-items").dataset.id,
        selector: ".js-contents",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
      {
        id: "cart-live-region-text",
        section: "cart-live-region-text",
        selector: ".shopify-section",
      },
      {
        id: "main-cart-footer",
        section: document.getElementById("main-cart-footer").dataset.id,
        selector: ".js-contents",
      },
    ];
  }

  updateQuantity(line, quantity, name, variantId) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement =
          document.getElementById(`Quantity-${line}`) ||
          document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll(".cart-item");

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute("value");
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        if (
          parsedState.items.length === 1 &&
          parsedState.items[0].handle === "shipping-protection"
        ) {
          let protection_remove = document.querySelector('.shipping-protection-remove');
          if(protection_remove){
            protection_remove.click()
          }
        }

        this.classList.toggle("is-empty", parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector("cart-drawer");
        const cartFooter = document.getElementById("main-cart-footer");

        if (cartFooter)
          cartFooter.classList.toggle("is-empty", parsedState.item_count === 0);
        if (cartDrawerWrapper)
          cartDrawerWrapper.classList.toggle(
            "is-empty",
            parsedState.item_count === 0
          );

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document
              .getElementById(section.id)
              .querySelector(section.selector) ||
            document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });
        const updatedValue = parsedState.items[line - 1]
          ? parsedState.items[line - 1].quantity
          : undefined;
        let message = "";
        if (
          items.length === parsedState.items.length &&
          updatedValue !== parseInt(quantityElement.value)
        ) {
          if (typeof updatedValue === "undefined") {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace(
              "[quantity]",
              updatedValue
            );
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) ||
          document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(
                cartDrawerWrapper,
                lineItem.querySelector(`[name="${name}"]`)
              )
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(
            cartDrawerWrapper.querySelector(".drawer__inner-empty"),
            cartDrawerWrapper.querySelector("a")
          );
        } else if (document.querySelector(".cart-item") && cartDrawerWrapper) {
          trapFocus(
            cartDrawerWrapper,
            document.querySelector(".cart-item__name")
          );
        }
console.log("add check", PUB_SUB_EVENTS.cartUpdate)
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: "cart-items",
          cartData: parsedState,
          variantId: variantId,
        });
      })
      .catch(() => {
        this.querySelectorAll(".loading__spinner").forEach((overlay) =>
          overlay.classList.add("hidden")
        );
        const errors =
          document.getElementById("cart-errors") ||
          document.getElementById("CartDrawer-CartErrors");
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        upsellProductSelection();
        checkboxmain();
        this.disableLoading(line);
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) ||
      document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError)
      lineItemError.querySelector(".cart-item__error-text").innerHTML = message;

    this.lineItemStatusElement.setAttribute("aria-hidden", true);

    const cartStatus =
      document.getElementById("cart-live-region-text") ||
      document.getElementById("CartDrawer-LiveRegionText");
    cartStatus.setAttribute("aria-hidden", false);

    setTimeout(() => {
      cartStatus.setAttribute("aria-hidden", true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems =
      document.getElementById("main-cart-items") ||
      document.getElementById("CartDrawer-CartItems");
    mainCartItems.classList.add("cart__items--disabled");

    const cartItemElements = this.querySelectorAll(
      `#CartItem-${line} .loading__spinner`
    );
    const cartDrawerItemElements = this.querySelectorAll(
      `#CartDrawer-Item-${line} .loading__spinner`
    );

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) =>
      overlay.classList.remove("hidden")
    );

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute("aria-hidden", false);
  }

  disableLoading(line) {
    const mainCartItems =
      document.getElementById("main-cart-items") ||
      document.getElementById("CartDrawer-CartItems");
    mainCartItems.classList.remove("cart__items--disabled");

    const cartItemElements = this.querySelectorAll(
      `#CartItem-${line} .loading__spinner`
    );
    const cartDrawerItemElements = this.querySelectorAll(
      `#CartDrawer-Item-${line} .loading__spinner`
    );

    cartItemElements.forEach((overlay) => overlay.classList.add("hidden"));
    cartDrawerItemElements.forEach((overlay) =>
      overlay.classList.add("hidden")
    );
  }
}

customElements.define("cart-items", CartItems);

if (!customElements.get("cart-note")) {
  customElements.define(
    "cart-note",
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          "change",
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, {
              ...fetchConfig(),
              ...{ body },
            });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}
function checkboxmain(){
  document.querySelectorAll('.checkmain').forEach(function(ele) {
  ele.addEventListener("change", function(e) {
    e.preventDefault();

    const cartItem = ele.closest(".cart-item");
    const variantId = cartItem.getAttribute("data-variant-id");
    const sellingPlanId = cartItem.getAttribute("data-sellingplanm");
    const quantity = parseInt(cartItem.getAttribute("data-quantity")) || 1;
    const removeBtn = cartItem.querySelector(".cart-remove-button");
   
    if (!variantId || !removeBtn) {
      console.error("Missing variantId or remove button");
      return;
    }
     document.body.classList.add('loader_added');
    // ✅ Capture the checkbox state BEFORE removing
    if (ele.checked)
    var isChecked = true;
  else{
    var isChecked = false;
  }
      
    // ✅ Remove the current item via click
    removeBtn.click();

    // ⏱ Wait for the removal to process (Shopify delay)
    setTimeout(() => {
      const params = new URLSearchParams();
      params.append('id', variantId);
      params.append('quantity', quantity);

      // ☑️ Unchecked → add with selling plan
      if (isChecked == true && sellingPlanId && sellingPlanId !== "false") {
        params.append('selling_plan', sellingPlanId);
        console.log("Adding with selling plan:", sellingPlanId);
      } else {
        // 🔲 Checked → no selling plan
        console.log("Adding without selling plan");
      }

      // ✅ Add item back
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'Accept': 'application/json'
        },
        body: params.toString()
      })
      .then(res => {
        if (!res.ok) {
          return res.text().then(text => {
            throw new Error(`Add to cart failed: ${text}`);
          });
        }
        return res.json();
      })
      .then(data => {
        console.log('Cart updated:', data);
         // 👉 Update cart drawer
  fetch(`${routes.cart_url}?section_id=cart-drawer`)
    .then((response) => response.text())
    .then((responseText) => {
      const html = new DOMParser().parseFromString(responseText, 'text/html');
      const newDrawer = html.querySelector('#CartDrawer');

      if (newDrawer) {
        const existingDrawer = document.querySelector('#CartDrawer');
        existingDrawer.innerHTML = newDrawer.innerHTML;
        document.body.classList.add('overflow-hidden');
        document.documentElement.classList.add('overflow-hidden');
        document.querySelector('cart-drawer').classList.add('animate', 'active');
        document.querySelector(".cradrawermainbox").classList.remove("is-empty")
      }
      var cartIconBubble = document.getElementById('cart-icon-bubble');

            fetch(window.location.href)
              .then(response => response.text())
              .then(data => {
                var tempElement = document.createElement('div');
                tempElement.innerHTML = data;
            
                var newCartIconBubble = tempElement.querySelector('#cart-icon-bubble');
            
                if (newCartIconBubble) {
                  cartIconBubble.innerHTML = newCartIconBubble.innerHTML;
                }
              })
              .catch(error => {
                console.error('Error:', error);
              });
      document.body.classList.remove('loader_added');
      checkboxmain()
    })
    .catch((error) => {
      console.error('Error updating cart drawer:', error);
      document.body.classList.remove('loader_added');
    });
      })
      .catch(error => {
        console.error('Error re-adding item:', error);
        document.body.classList.remove('loader_added');
      });

    }, 800); // Adjust delay as needed
  });
});
}
function upsellProductSelection(){
  document.querySelectorAll('.cart-upsell-option').forEach(select => {
    select.addEventListener('change', function () {
        let parentDiv = this.closest('.upsell-product-card');
        let img = parentDiv.querySelector('.upsell-product-image img');
        let priceDiv = parentDiv.querySelector('.upsell-product-price');
        let scriptTag = parentDiv.querySelector('script[type="application/json"]');
        let variantjson = JSON.parse(scriptTag.innerHTML);
        let opts = [];

        parentDiv.querySelectorAll('.cart-upsell-option').forEach(optSelect => {
            opts.push(optSelect.value);
        });

        let selectedVar = variantjson.filter(v => 
            v.option1 == opts[0] && v.option2 == opts[1] && v.option3 == opts[2]
        );

        let submitButton = parentDiv.querySelector('.quick-add__submit');
        let addToCartText = submitButton.querySelector('span:not(.sold-out-message)');
        let id_input = parentDiv.querySelector('input[name="id"');
        let selectedVarImg = selectedVar[0].featured_image.src;
        if(selectedVarImg && img){
          img.src = selectedVarImg;
          img.srcset = selectedVarImg;
        }

        if (!selectedVar[0] || selectedVar[0].available === false) {
            submitButton.setAttribute('disabled', 'true');
            addToCartText.textContent = 'Sold out';
        } else {
          let selectedVarId = selectedVar[0].id;
          let selectVarOpt = document.querySelector(`select.upsell-variant option[value="${selectedVarId}"]`);
            submitButton.removeAttribute('disabled');
            addToCartText.textContent = 'Add to bag';
            id_input.value = selectedVarId;
            if(selectVarOpt){
              let selectVarPrice = selectVarOpt.dataset.price;
              priceDiv.innerHTML = selectVarPrice;
            }
        }
    });
});
    var swiper = new Swiper(".upsell-slider-1", {
    slidesPerView: 1,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });
}
document.addEventListener('DOMContentLoaded', function(){
upsellProductSelection();
 checkboxmain();
});





function updateConvertedAttributec(el) {
  // Get the base USD cents from attributes
  var usdCents = parseInt(el.getAttribute("data-pck"), 10);
  
  
  if (isNaN(usdCents)) return;

  // Convert cents → dollars first
var usdAmount = usdCents / 100;


  // Get active currency
  var activeCurrency = Shopify.currency.active || "USD";
  console.log(activeCurrency)
  var baseCurrency = Shopify.currency.default || "USD";

  // Get conversion rate
  var convertedAmount = (usdAmount * Shopify.currency.rate).toFixed(2);

  

  el.setAttribute("data-pck", "$" + convertedAmount);
  el.textContent="$" + convertedAmount;


  
}


document.querySelectorAll(".cart-item__old-price.product-option").forEach(updateConvertedAttributec);


setInterval(() => {
  document.querySelectorAll(".cart-item__old-price.product-option").forEach(updateConvertedAttributec);
}, 500);


function calculateCartSavingsFromText() {
  let totalCompareAt = 0;
  let totalPrice = 0;

  // Select all compare-at-price elements
  const compareAtElements = document.querySelectorAll(".cart-item__old-price.product-option");
  compareAtElements.forEach(el => {
    let value = parseFloat(el.textContent.replace(/[^0-9.]/g, "")); // remove $ and convert

    if (!isNaN(value)) totalCompareAt += value;
  });

  // Select all final-price elements
  const priceElements = document.querySelector(".totals__total-value");
  totalPrice = parseFloat(priceElements.textContent.replace(/[^0-9.]/g, ""));
  
  // console.log(totalCompareAt);
  // console.log(totalPrice)
  const savings = totalCompareAt - totalPrice;

  return {
    totalCompareAt: totalCompareAt.toFixed(2),
    totalPrice: totalPrice.toFixed(2),
    savings: savings.toFixed(2)
  };
}

// Update savings every 500ms
setInterval(() => {
  const cartSummary = calculateCartSavingsFromText();
  const totalSaving = document.querySelector(".savetotlebox p");
  if (totalSaving) {
    totalSaving.textContent = "$" + cartSummary.savings; // add $ symbol
  }
}, 500);
